import { useState } from 'react';

// --- ICONS (no changes) ---
const CloseIcon = () => ( <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg> );
const PlusIcon = () => ( <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" /></svg> );
const TrashIcon = () => ( <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" /></svg> );

// --- Objek Templates (no changes) ---
const templates = {
    'KTP':{icon:'👤',fields:[{name:'NIK',type:'Number'},{name:'Nama',type:'Text'},{name:'Jenis Kelamin',type:'Selection',options:[{value:'Laki-laki'},{value:'Perempuan'}]},{name:'Tempat Lahir',type:'Text'},{name:'Tanggal Lahir',type:'Date'},]},
    'KK':{icon:'👨‍👩‍👧‍👦',fields:[{name:'Nomor KK',type:'Number'},{name:'Nama Kepala Keluarga',type:'Text'},{name:'Alamat',type:'Text'},{name:'RT/RW',type:'Text'},{name:'Desa/Kelurahan',type:'Text'},{name:'Kecamatan',type:'Text'},{name:'Kabupaten/Kota',type:'Text'},{name:'Provinsi',type:'Text'},{name:'Tanggal Dikeluarkan',type:'Date'},]},
    'Akta Kelahiran':{icon:'📜',fields:[{name:'Nomor Akta',type:'Text'},{name:'Nama Lengkap',type:'Text'},{name:'Jenis Kelamin',type:'Selection',options:[{value:'Laki-laki'},{value:'Perempuan'}]},{name:'Tempat Lahir',type:'Text'},{name:'Tanggal Lahir',type:'Date'},{name:'Nama Ayah',type:'Text'},{name:'Nama Ibu',type:'Text'},]},
    'Custom':{icon:'⚙️',fields:[]}
};
const templateNames = Object.keys(templates);

export default function AddDocumentModal({ isOpen, onClose }) {
    // --- State and handlers (no changes) ---
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [docTypeName, setDocTypeName] = useState('');
    const [fields, setFields] = useState([]);
    const handleSelectTemplate = (templateName) => {
        setSelectedTemplate(templateName);
        const templateData = templates[templateName];
        setDocTypeName(templateName === 'Custom' ? '' : templateName);
        if (templateData.fields && templateData.fields.length > 0) {
            const newFields = templateData.fields.map(field => ({
                id: Date.now() + Math.random(),
                name: field.name,
                type: field.type,
                options: field.options ? field.options.map(opt => ({ id: Date.now() + Math.random(), value: opt.value })) : []
            }));
            setFields(newFields);
        } else {
            setFields([{ id: Date.now(), name: '', type: 'Text', options: [] }]);
        }
    };
    const handleAddField = () => {setFields([...fields, { id: Date.now(), name: '', type: 'Text', options: [] }]);};
    const handleRemoveField = (id) => {setFields(fields.filter(field => field.id !== id));};
    const handleFieldChange = (id, event) => {const { name, value } = event.target; setFields(fields.map(field => field.id === id ? { ...field, [name]: value } : field));};
    const handleAddOption = (fieldId) => {setFields(fields.map(field =>field.id === fieldId? { ...field, options: [...field.options, { id: Date.now(), value: '' }] }: field));};
    const handleOptionChange = (fieldId, optionId, event) => {const { value } = event.target;setFields(fields.map(field =>field.id === fieldId? { ...field, options: field.options.map(opt => opt.id === optionId ? { ...opt, value } : opt) }: field));};
    const handleRemoveOption = (fieldId, optionId) => {setFields(fields.map(field =>field.id === fieldId? { ...field, options: field.options.filter(opt => opt.id !== optionId) }: field));};
    const handleSave = async () => {
        // Validasi nama tipe dokumen
        if (!docTypeName.trim()) {
            alert("Nama tipe dokumen wajib diisi");
            return;
        }
        // Siapkan expectation sesuai format backend
        const expectation = {};
        fields.forEach(field => {
            if (!field.name.trim()) return;
            if (field.type === "Selection") {
                expectation[field.name] = {
                    type: "selection",
                    options: field.options.map(opt => opt.value).filter(Boolean)
                };
            } else if (field.type === "Number") {
                expectation[field.name] = "number";
            } else if (field.type === "Date") {
                expectation[field.name] = "date";
            } else {
                expectation[field.name] = "text";
            }
        });

        try {
            const org = localStorage.getItem('selected_organization');
            if (!org) throw new Error("Organisasi belum dipilih");
            const { organization_id } = JSON.parse(org);

            const res = await fetch("https://bot.kediritechnopark.com/webhook/create-data-type", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    organization_id,
                    nama_tipe: docTypeName,
                    expectation,
                }),
            });
            if (!res.ok) {
                const errData = await res.json().catch(() => ({}));
                throw new Error(errData.message || "Gagal menambah jenis dokumen");
            }
            // Reset state dan tutup modal
            setSelectedTemplate(null);
            setDocTypeName('');
            setFields([]);
            onClose();
            // Jika DashboardPage Anda memakai onSuccess, panggil juga di sini:
            // if (typeof onSuccess === "function") onSuccess();
        } catch (err) {
            alert(err.message);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white w-full max-w-lg rounded-2xl shadow-xl p-6 sm:p-8 relative">
                <button onClick={()=>{setSelectedTemplate(null); onClose();}} className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"><CloseIcon/></button>
                <h3 className="text-xl font-bold text-gray-800 mb-6">Tambah Jenis Dokumen Baru</h3>
                
                {!selectedTemplate &&
                <div>
                    <label className="font-semibold text-gray-700">Pilih Template</label>
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-2">
                        {templateNames.map(name => (
                            <div key={name} onClick={() => handleSelectTemplate(name)} className={`p-4 border-2 rounded-xl text-center cursor-pointer transition-all duration-200 ${selectedTemplate === name ? 'border-yellow-400 ring-2 ring-yellow-200' : 'border-gray-200 hover:border-blue-500'}`}>
                                <span className="text-3xl">{templates[name].icon}</span>
                                <p className="font-semibold text-sm mt-2">{name}</p>
                            </div>
                        ))}
                    </div>
                </div>
                }

                {selectedTemplate && (
                    <div className="mt-6 border-t pt-6">
                        <div>
                            <label htmlFor="docTypeName" className="font-semibold text-gray-700">Nama Tipe Dokumen</label>
                            <input type="text" id="docTypeName" value={docTypeName} onChange={(e) => setDocTypeName(e.target.value)} placeholder="Contoh: KTP, KK, Ijazah, dll" className="w-full mt-2 p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 transition"/>
                        </div>
                        <div className="mt-6">
                            <label className="font-semibold text-gray-700">Ekspektasi data</label>
                            <div className="space-y-4 mt-2 max-h-[40vh] overflow-y-auto pr-2">
                                {fields.map((field) => (
                                     // PERUBAHAN: Menambahkan class `relative` dan `pt-4` pada container field
                                    <div key={field.id} className="p-3 pt-4 bg-gray-50 rounded-lg border relative">
                                        
                                        {/* PERUBAHAN: Tombol hapus dipindah ke sini dan diubah gayanya */}
                                        <button 
                                            onClick={() => handleRemoveField(field.id)} 
                                            className="absolute top-1 right-1 w-7 h-7 bg-red-500 text-white rounded-full hover:bg-red-600 flex items-center justify-center border-2 border-white"
                                        >
                                            <TrashIcon/>
                                        </button>

                                        <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                                            <input type="text" name="name" placeholder="Nama field" value={field.name} onChange={(e) => handleFieldChange(field.id, e)} className="flex-grow p-3 border border-gray-300 rounded-lg"/>
                                            <select name="type" value={field.type} onChange={(e) => handleFieldChange(field.id, e)} className="p-3 border border-gray-300 rounded-lg bg-white w-full sm:w-auto">
                                                <option>Text</option><option>Number</option><option>Date</option><option>Selection</option>
                                            </select>
                                            {/* Tombol hapus yang lama sudah dihapus dari sini */}
                                        </div>
                                        {field.type === 'Selection' && (
                                            <div className="mt-3 pl-2 border-l-2 border-blue-200">
                                                <div className="space-y-2">
                                                    {field.options.map(option => (
                                                        <div key={option.id} className="flex items-center space-x-2">
                                                            <input type="text" placeholder="Nama pilihan" value={option.value} onChange={(e) => handleOptionChange(field.id, option.id, e)} className="flex-grow p-2 text-sm border border-gray-200 rounded-md"/>
                                                            <button onClick={() => handleRemoveOption(field.id, option.id)} className="flex-shrink-0 w-7 h-7 bg-gray-200 text-gray-600 rounded hover:bg-red-200 hover:text-red-700 flex items-center justify-center text-xs">X</button>
                                                        </div>
                                                    ))}
                                                </div>
                                                <button onClick={() => handleAddOption(field.id)} className="mt-2 text-sm text-blue-600 font-semibold hover:underline">+ Tambah Ekspektasi Pilihan</button>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                            <button onClick={handleAddField} className="w-full mt-3 bg-blue-500 text-white font-bold py-3 px-4 rounded-lg hover:bg-blue-600 transition-colors flex items-center justify-center"><PlusIcon/>Tambah Field</button>
                        </div>
                        <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-3 mt-8">
                            <button onClick={handleSave} className="py-2 px-6 bg-gray-800 text-white font-semibold rounded-lg hover:bg-gray-900">Tambah</button>
                            <button onClick={()=>{setSelectedTemplate(null); onClose();}} className="py-2 px-6 bg-gray-100 text-gray-700 font-semibold rounded-lg hover:bg-gray-200">Batal</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}